
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M0.309956 2.00002C-0.0800439 2.39002 -0.0800439 3.02002 0.309956 3.41002L0.999956 4.09002V16C0.999956 17.1 1.89996 18 2.99996 18H9.99996V20H8.99996C8.44996 20 7.99996 20.45 7.99996 21C7.99996 21.55 8.44996 22 8.99996 22H15C15.55 22 16 21.55 16 21C16 20.45 15.55 20 15 20H14V18H14.9L20.19 23.29C20.58 23.68 21.21 23.68 21.6 23.29C21.99 22.9 21.99 22.27 21.6 21.88L1.71996 2.00002C1.32996 1.61002 0.699956 1.61002 0.309956 2.00002ZM2.98996 15V6.09002L12.9 16H3.98996C3.43996 16 2.98996 15.55 2.98996 15ZM4.54996 2.00002L6.54996 4.00002H20C20.55 4.00002 21 4.45002 21 5.00002V15C21 15.55 20.55 16 20 16H18.55L20.55 18H20.99C22.09 18 22.99 17.1 22.99 16V4.00002C22.99 2.90002 22.09 2.00002 20.99 2.00002H4.54996Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-desktop-access-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDesktopAccessDisabled

    ```js
    <b-new-b-icon-desktop-access-disabled />
    ```
</docs>


